import { render, staticRenderFns } from "./psp-os.vue?vue&type=template&id=21d9aa58&"
import script from "./psp-os.vue?vue&type=script&lang=ts&"
export * from "./psp-os.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports